module.exports = __webpack_public_path__ + "img/checklist.8dda1066.svg";